<template>
  <div class="display-tag" 
    :class="{'display-tag__focused':hasFocus}"
    @mouseup="onWaypointSelect()"
    @mousedown.stop="isSelectable=true"
    @mouseover="onMouseOver"
    @mouseleave="onMouseLeave">
    <!---->
    <vue-draggable-resizable v-if="waypointToDisplay.isActive"
      class-name="display-tag__active-tag"
      class-name-handle="display-tag__handle"
      :class="displayTagClass"
      :active="false"
      :resizable="isSelected"
      :draggable="isSelected"
      :w="coordinates.w" 
      :h="coordinates.h" 
      :x="coordinates.x" 
      :y="coordinates.y"
      @resizing="onResize"
      @dragging="onDrag">
      <preview-tag :tag="waypointToDisplay.tag" class="display-tag__active-tag-content"></preview-tag>
      <div class="tag-waypoint__controls" v-show="hasFocus" v-bind:style="controlsStyle">
        <div v-tooltip.right-start="'Delete this waypoint'"  class="tag-waypoint__delete" @mouseup.stop="onWaypointDelete()">
          <i class="material-icons">delete</i>
        </div>
        <div v-tooltip.right-start="'apply to all'"  class="tag-waypoint__commit" @mouseup.stop="onApplySizeAndPosition()">
          <i class="material-icons">format_paint</i>
        </div>
      </div>
    </vue-draggable-resizable>
    <!---->
    <div v-else class="display-tag__inactive-tag" :style="inactiveWaypointStyle" >
      <preview-tag  :tag="waypointToDisplay.tag" class="display-tag__inactive-tag-content"></preview-tag>
      <div v-show="hasFocus" class="tag-waypoint__controls" v-bind:style="controlsStyle">
        <div v-tooltip.right-start="'Create a waypoint on this keyframe'" class="tag-waypoint__commit" @mouseup.stop="onWaypointCreate()">
          <i class="material-icons">add</i>
        </div>
      </div>
    </div>
    <!---->
  </div>
</template>

<script>
import PreviewTag from './../previewTag'
import VueDraggableResizable from 'vue-draggable-resizable'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'

export default {
  name: 'displayTag',

  components: {
    'vue-draggable-resizable': VueDraggableResizable,
    'preview-tag' : PreviewTag
  },

  props: {
    waypointToDisplay: {
      type: Object,
      default: function () {
        return {}
      }
    },

    hasFocus: {
      type: Boolean,
      default: false
    },

    isSelected: {
      type: Boolean,
      default: true
    }
  },

  data: function () {
    return {
      isSelectable: true,
      arrangeModeLayerBoundingBox: null,
      mouseLeaving: false
    }
  },

  computed: {
    coordinates: function () {
      const coordinates = this.arrangeModeLayerBoundingBox ? {
        x: parseInt(this.arrangeModeLayerBoundingBox.width * (this.waypointToDisplay.wp.x - (this.waypointToDisplay.wp.pw / 2))),
        y: parseInt(this.arrangeModeLayerBoundingBox.height * (this.waypointToDisplay.wp.y - (this.waypointToDisplay.wp.ph / 2))),
        w: parseInt(this.arrangeModeLayerBoundingBox.width * this.waypointToDisplay.wp.pw),
        h: parseInt(this.arrangeModeLayerBoundingBox.height * this.waypointToDisplay.wp.ph)
      } : {
        x: 0,
        y: 0,
        w: 10,
        h: 10
      }

      return coordinates
    },
    
    displayTagClass: function () {
      return {
        'display-tag__selected-tag': this.isSelected,
        'display-tag__unselected-tag': !this.isSelected
      }
    },

    controlsStyle: function () {
      const wp = this.waypointToDisplay.wp
      const left = `${(wp.x + wp.w) + 10}px`
      const top = `${0}px`

      return {
        left: left,
        top: top,
      }
    },

    inactiveWaypointStyle: function () {
      return {
        top: `${this.coordinates.y}px`,
        left: `${this.coordinates.x}px`,
        height: `${this.coordinates.h}px`,
        width: `${this.coordinates.w}px`
      }
    }
  },

  created() {
    this.initDisplayTag()
  },

  methods: {
    initDisplayTag: function () {
      this.arrangeModeLayerBoundingBox = document.querySelector('.player-inner-wrapper').getBoundingClientRect()
    },

    onMouseOver: function () {
      this.mouseLeaving = false
      if (!this.hasFocus) {
        this.$emit('askFocus', this.waypointToDisplay.wp)
      }
    },

    onMouseLeave: function () {
      if (this.hasFocus) {
        this.mouseLeaving = true
        const that = this

        var mouseleave = new Promise(resolve => {
          setTimeout(() => {
            resolve(that.mouseLeaving)
          }, 250)
        })

        mouseleave.then(mouseLeaving => {
          if (mouseLeaving) {
            this.$emit('releaseFocus', this.waypointToDisplay.wp)
          }
        })
      }
      
    },

    onWaypointSelect: function (e) {
      if (this.isSelectable) {
        if (this.waypointToDisplay.isActive) {
          this.$emit('waypointSelect', this.waypointToDisplay)
        }
      }
    },

    onWaypointCreate: function () {
      this.$emit('waypointCreate', this.waypointToDisplay)
    },

    onWaypointDelete: function () {
      this.$emit('waypointDelete', this.waypointToDisplay)
    },

    onApplySizeAndPosition: function () {
      this.$emit('applySizeAndPosition', this.waypointToDisplay)
    },

    onDrag: function (x, y) {
      this.isSelectable = false

      const waypoint = this.waypointToDisplay.wp
      
      this.$emit('waypointMove', {x, y, waypoint})
    },

    onResize: function (x, y, width, height) {
      this.isSelectable = false

      const waypoint = this.waypointToDisplay.wp

      this.$emit('waypointResize', {width, height, waypoint})
      this.$emit('waypointMove', {x, y, waypoint})
    }
  }
}
</script>
